import moment from 'moment-timezone';

/**
 * Send ticket created datetime in local wall time (no Z).
 * Prevents UTC split('T')[0] from turning Aug 23 9:57pm Chicago into 2026-08-24.
 */
export const toTicketCalendarDateTime = (value) => {
  if (value == null || value === '') return value;
  return moment(value).format('YYYY-MM-DDTHH:mm:ss');
};

/**
 * Top-right Ticket Date on the delivery ticket.
 * Uses the ticket's Date Created (ticket_p), not the last update or the invoice date.
 */
export const formatTicketCreatedDate = (ticketLike) => {
  const value =
    ticketLike && typeof ticketLike === 'object'
      ? ticketLike.ticket_date_created ||
        ticketLike.date_created ||
        ticketLike.dateTime ||
        ticketLike.date_updated
      : ticketLike;
  if (value == null || value === '') return '';
  const parsed = moment(value);
  if (!parsed.isValid()) return '';
  return parsed.format('MMM, DD YYYY');
};
